import { defineStore } from "pinia";

export const useAuth = defineStore("auth",{
    state: () => {
        return {
            token: null,
            users:[],
            id_user: null,
            baseUrl: "https://appathome.ivancano.com/api"
            // baseUrl: "http://localhost:3004/api"
        }
    },
    getters: {
        
    },
    actions: {
        async login(email, password) {
            const uri = `${this.baseUrl}/users/login`

            const rawResponse = await fetch(uri, {
                method: "POST",
                headers: {
                    'Content-Type': 'Application/json',
                    'Accepts': 'Application/json'
                },
                body: JSON.stringify({
                    "email": email,
                    "password": password
                })
            })

            const response = await rawResponse.json()

            if(response.status == false) {
                this.token = null
                this.id_user = null
                return false
            } else {
                this.token = response.data.token
                this.id_user = response.data.id_user
                return true
            }
        },
        async getUsers() {
            const uri = `${this.baseUrl}/users`

            const rawResponse = await fetch(uri, {
                method: "GET",
                headers: {
                    'Content-Type': 'Application/json',
                    'Accepts': 'Application/json',
                    'Authorization': `Bearer ${this.token}`
                }
            })

            const response = await rawResponse.json()
            this.users = response.data
        },
        async updateStatus(is_home) {
            const uri = `${this.baseUrl}/users/updatestatus/${this.id_user}`
            const user = this.users.find(u => u.id_user === this.id_user)
            const rawResponse = await fetch(uri, {
                method: "PUT",
                headers: {
                    'Content-Type': 'Application/json',
                    'Accepts': 'Application/json',
                    'Authorization': `Bearer ${this.token}`
                },
                body: JSON.stringify({
                    is_home
                })
            })

            const response = await rawResponse.json()

            if(response.success) {
                user.is_home = is_home
            }
            return response
        }
    },
    persist: true
})

export default useAuth